import { createContext, useContext, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';

import type { ImageVariations } from '#src/lib/share.ts';

export interface Options {
  description?: string;
  img?: string | Record<ImageVariations, string | null> | null;
  twitter?: string;
  replaceFullTitle?: boolean;
  noindex?: boolean;
}

type SeoContext = {
  setPageMetadata: (seoTitle: string, options?: Options) => () => void;
  /** Drops canonical and hreflang until the returned cleanup runs. */
  registerNoIndex: () => () => void;
  /** Sets the canonical to `pathname` and drops hreflang until the returned cleanup runs. */
  registerCanonical: (pathname: string) => () => void;
};

export const SeoContext = createContext<SeoContext | null>(null);

export const useSeoContext = () => useContext(SeoContext)!;

export const NoIndex = () => {
  const registerNoIndex = useContext(SeoContext)?.registerNoIndex;

  useEffect(() => registerNoIndex?.(), [registerNoIndex]);

  return (
    <Helmet>
      <meta name="robots" content="noindex" />
    </Helmet>
  );
};

/** For a page that duplicates another one: points the canonical to it. */
export const Canonical = ({ pathname }: { pathname: string }) => {
  const registerCanonical = useContext(SeoContext)?.registerCanonical;

  useEffect(() => registerCanonical?.(pathname), [registerCanonical, pathname]);

  return null;
};
